import type { RunSummary } from './score';
import { buildInvite } from './report';

/** 复制文本到剪贴板，按钮短暂显示结果。 */
export async function copyToClipboard(
  text: string, btn: HTMLElement,
): Promise<void> {
  const old = btn.textContent;
  try {
    await navigator.clipboard.writeText(text);
    btn.textContent = '已复制 ✓';
  } catch {
    btn.textContent = '复制失败';
  }
  setTimeout(() => { btn.textContent = old; }, 1400);
}

/** 复制邀请语（战报 + 链接）。 */
export function copyInvite(
  summary: RunSummary | null, btn: HTMLElement,
): void {
  if (!summary) return;
  const base = `${location.origin}${location.pathname}`;
  void copyToClipboard(buildInvite(summary, base), btn);
}
